export const Style = ({ colors }) => (
  <g id="Estilo2_1_">
    <path
      style={{ display: 'inline', fill: colors[0] }}
      d="M86.1,63.6c0,1.6-0.5,2.9-1.2,2.9s-1.2-1.3-1.2-2.9c0-1.6,0.5-2.9,1.2-2.9 C85.6,60.7,86.1,62,86.1,63.6z"
    />
    <path
      style={{ display: 'inline', fill: colors[0] }}
      d="M65.1,63.6c0,1.6,0.5,2.9,1.2,2.9s1.2-1.3,1.2-2.9c0-1.6-0.5-2.9-1.2-2.9 S65.1,62,65.1,63.6z"
    />
    <path
      style={{ display: 'inline', fill: '#FF9673' }}
      d="M63.4,73.4c-0.1,0-0.2,0-0.2-0.1c-0.3-0.1-0.4-0.4-0.3-0.7l1.7-3.5 c0.1-0.3,0.4-0.4,0.7-0.3c0.3,0.1,0.4,0.4,0.3,0.7l-1.7,3.5C63.8,73.3,63.6,73.4,63.4,73.4z"
    />
    <path
      style={{ display: 'inline', fill: '#FF9673' }}
      d="M60,73.4c-0.1,0-0.2,0-0.2-0.1c-0.3-0.1-0.4-0.4-0.3-0.7l1.7-3.5 c0.1-0.3,0.5-0.4,0.7-0.3s0.4,0.4,0.3,0.7l-1.7,3.5C60.4,73.3,60.2,73.4,60,73.4z"
    />
    <path
      style={{ display: 'inline', fill: '#FF9673' }}
      d="M87.5,73.4c-0.2,0-0.4-0.1-0.5-0.3l-1.7-3.5c-0.1-0.3,0-0.6,0.3-0.7 c0.3-0.1,0.6,0,0.7,0.3l1.7,3.5c0.1,0.3,0,0.6-0.3,0.7C87.7,73.4,87.6,73.4,87.5,73.4z"
    />
    <path
      style={{ display: 'inline', fill: '#FF9673' }}
      d="M90.9,73.4c-0.2,0-0.4-0.1-0.5-0.3l-1.7-3.5c-0.1-0.3,0-0.6,0.3-0.7 c0.3-0.1,0.6,0,0.7,0.3l1.7,3.5c0.1,0.3,0,0.6-0.3,0.7C91.1,73.4,91,73.4,90.9,73.4z"
    />
  </g>
)
